import { api } from './client.js';

/**
 * 리뷰 관리 — 원본 zaiko/filter_review_list.php.
 * 계산은 서버(reviewBoard.service.ts)가 끝내서 내려준다.
 */
export type ReviewOrderBy = 'index_no' | 'subject' | 'readcount' | 'wdate';
export type ReviewCategory = 'photoafter' | 'textafter';

export interface ReviewBoardRow {
  indexNo: number;
  boardId: string;
  boardLabel: string;
  memIdx: number;
  memName: string;
  marketIdx: string;
  subject: string;
  thumbnail: string;
  readcount: number;
  wdate: string;
  isDuplicate: boolean;
  colorGroup: number;
}

export interface ReviewBoardListParams {
  page: number;
  search: string;
  category: ReviewCategory;
  /** 'YYYY-MM' 또는 '' */
  start: string;
  /** 'YYYY-MM' 또는 '' */
  end: string;
  orderby: ReviewOrderBy;
  order: 'ASC' | 'DESC';
}

export interface MergeResult {
  ok: true;
  targetId: number;
  mergedCount: number;
}

export const reviewBoardApi = {
  list: (p: ReviewBoardListParams) =>
    api.get<{ items: ReviewBoardRow[] }>(
      `/reports/review-board/list?${new URLSearchParams({
        page: String(p.page),
        search: p.search,
        category: p.category,
        start: p.start,
        end: p.end,
        orderby: p.orderby,
        order: p.order,
      }).toString()}`,
    ),

  merge: (ids: number[]) => api.post<MergeResult>('/reports/review-board/merge', { ids }),
};
